/* file.icon.svg.js */

module.exports = {
    icon: `
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.7 20.5" preserveAspectRatio="none">
        <path class="foreground-gl" d="M13.74,5.82h4L13.36,1.25V5.44A.38.38,0,0,0,13.74,5.82Z"/>
        <path class="foreground-gl" d="M3.35,18.87a1.49,1.49,0,0,0,1.49,1.49h12a1.49,1.49,0,0,0,1.49-1.49V7.71H13.74a2.27,2.27,0,0,1-2.26-2.27V.59H4.86a1.5,1.5,0,0,0-1.5,1.5Z"/>
        </svg>
    `
};
